<template>
  <v-row class="mt-4" no-gutters>
    <v-col class="pa-2" cols="12" md="4">
      <v-card
        class="rounded-lg pa-3 user-link-wrapper overflow-hidden"
        color="grey lighten-3"
        flat
      >
        <v-slide-x-transition mode="out-in">
          <v-card
            v-if="!isIntersecting || $route.name !== 'profile'"
            class="rounded-lg overflow-hidden clickable"
            flat
            width="100%"
            @click="goToTop"
          >
            <v-img src="/media/profile/terminal_profile_bg.webp" width="100%" />
          </v-card>
        </v-slide-x-transition>

        <v-list color="transparent" :class="{ rtl: isRtl }">
          <v-list-item-group v-model="userLinkModel" color="primary">
            <template v-for="(x, i) in userLinks">
              <v-list-item
                v-if="x.name === $route.name"
                :key="'active-' + i"
                :href="x.link"
                class="primary white--text rounded-lg mb-2"
                dark
                link
                two-line
              >
                <v-list-item-icon class="white rounded-pill pa-3 my-3">
                  <v-icon color="primary">mdi-{{ x.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{
                    $t(`userLinks.${x.name}.title`)
                  }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon>mdi-chevron-{{ isRtl ? "right" : "left" }}</v-icon>
                </v-list-item-action>
              </v-list-item>

              <v-list-item
                v-else
                :key="i"
                :href="x.link"
                class="rounded-lg overflow-hidden"
                link
              >
                <v-list-item-icon class="me-3">
                  <v-icon color="primary">mdi-{{ x.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{
                    $t(`userLinks.${x.name}.title`)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-col>

    <v-col class="pa-2" cols="12" md="8">
      <profile-view
        v-if="$route.name === 'profile'"
        :intersect.sync="isIntersecting"
      />
      <router-view v-else />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import ProfileView from "./userInfo/profileView";
import i18n from "@/i18n";

export default {
  name: "newProfile",

  components: { ProfileView },

  data: () => ({
    i18n,
    userLinks: [
      {
        title: "overview",
        name: "profile",
        icon: "account-outline",
        link: "#/profile",
      },
      {
        title: "invite_friends",
        name: "profile.invitation",
        icon: "account-multiple-plus-outline",
        link: "#/profile/invite-friends",
      },
      {
        title: "personal_info",
        name: "profile.info",
        icon: "badge-account-outline",
        link: "#/profile/info",
      },
      {
        title: "edit_profile",
        name: "profile.edit",
        icon: "account-edit-outline",
        link: "#/profile/edit-personal",
      },
      {
        title: "change_password",
        name: "profile.changePass",
        icon: "lock-reset",
        link: "#/profile/change-password",
      },
    ],
    profileLinks: [
      { text: "orders", link: "#/menu/profile/orders", icon: "store-clock" },
      {
        text: "addresses",
        link: "#/menu/profile/addresses",
        icon: "map-marker-path",
      },
    ],
    isIntersecting: true,
    userLinkModel: 0,
    colors: ["blue lighten-2", "green", "third", "orange"],
  }),

  mounted() {
    this.userLinkModel = this.userLinks.findIndex(
      (item) => item.name === this.$route.name
    );
    this.$i18n.locale = this.getLocale();
  },

  computed: {
    ...mapGetters("ribbon", ["new_wallet"]),
    wallet() {
      return this.new_wallet;
    },
    isRtl() {
      return ["fa", "ar"].includes(this.$i18n.locale);
    },
  },

  methods: {
    goToTop() {
      window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
    },
    getLocale() {
      return this.$i18n.locale || "fa"; // Default to Persian
    },
  },
};
</script>

<style lang="scss" scoped>
.user-link-wrapper {
  position: sticky;
  top: 96px;
}

.details-wrapper {
  label {
    margin-right: 4px;
  }
}

.rtl {
  direction: rtl;
  text-align: right;
}
</style>
